<template>
    <div class="homepage-reviews">
        <h2 class="comm-title">精选游记</h2>
        <h3 class="comm-subtitle">爱上游轮&emsp;爱上皇家加勒比</h3>
        <ul class="reviews-content">
            <li v-for="(item, i) in reviews" :key="i" class="review-content" @click="goDetail(item.id)">
                <img :src="item.image" alt="" />
                <div class="rev-title">{{item.title}}</div>
                <div class="rev-name-time">{{item.shipName}}&nbsp;&nbsp;|&nbsp;&nbsp;{{item.sailDate}}</div>
                <div class="rev-name">
                    {{item.route}}
                </div>
                <div class="rev-bottom">
                    <img class="tag-img" src="https://resource.rcclchina.com.cn/logo/MB/logoAvatarCircleBlue.png" alt="" />
                    <span class="tag">{{item.author}}</span>
                    <span class="review-score-content" :class="{'upvoted': item.isUpvoted}" @click.stop="onUpvoteClick($event, item)">
                        <img v-if="item.isUpvoted" class="zan-img score-image" src="https://resource.rcclchina.com.cn/Review/upvote/upvoted-1.png"/>
                        <img v-if="!item.isUpvoted"  class="zan-img score-image" src="https://resource.rcclchina.com.cn/Review/upvote/noupvote.png"/>
                        <span class="zan review-score">{{item.score.toFixed(0)}}</span>
                    </span>
                </div>
            </li>
        </ul>
        <a class="btn-link external" href="/Rccl.Review/Travel/tn-n-n-0-0-9.html">更多精选游记</a>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: 'HomeReview',
    props: {
        reviewArticles: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            reviews: []
        }
    },
    beforeMount () {
        this.reviews = [...this.reviewArticles]
        this.getUpvote()
    },
    methods: {
        getUpvoteByReview(reviewId) {
            return this.upvoteData.find(r=>r.id == reviewId) || {}
        },
        goDetail (itemId) {
            this.$router.push(`/Rccl.Review/Travel/d-n-n-0-0-${itemId}.html`)
        },
        async onUpvoteClick (e, review) {
            e.stopPropagation()
            if (review.isUpvoted) {
                this.$alert.show("您已点过赞了")
                return
            } else {
                this.$loading.show()
                const { success, data , errMsg } = await api.review.upvote({
                    userId: this.$store.state.user.userReviewToken,
                    articalId: review.id
                })
                if (data != this.$store.state.user.userReviewToken) {
                    this.$store.commit('SET_REWARD_TOKEN', data)
                }
                this.$loading.hide()
                if (!success) {
                    this.$alert.show(errMsg)
                    return
                }
                review.score++
                review.isUpvoted = true

            }
        },
        async getUpvote () {
            const reviewIds = this.reviewArticles.map(r=>r.id)
            const reviewUserId =  this.$store.state.user.userReviewToken
            if (reviewIds.length == 0) return
            const { success, data } = await api.review.getUpvote({
                reviewIds,
                reviewToken: reviewUserId
            })
            if (!success) {
                return
            }
            this.reviews.forEach((review) => {
                const upvoteReview = data.find(r=>r.id == review.id)
                if (upvoteReview) {
                    review.score = upvoteReview.score
                    review.isUpvoted = upvoteReview.isUpvoted
                }
            })
        }
    },
    watch: {
        reviewArticles(newValue) {
            this.reviews = [...newValue]
            this.getUpvote()
        }
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    list-style: none;
    
    text-transform: uppercase;
}
img{
    display:block;
}
.btn-link{
    display:block;
    width: 345px;
    height: 45px;
    border: 1px solid #0073bb;
    line-height: 45px;
    text-align: center;
    color: #0073bb;
    margin: 0 auto;
}


.comm-title{
    width: 100%;
    text-align: center;
    font-size: 23px;
    font-weight: bold;
    color: #282b2c;
    line-height: 33px;
}
.comm-subtitle{
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    color: #282b2c;
    line-height: 22px;
    text-align:center;
    margin-bottom: 15px;
}


/*精选游记*/
.homepage-reviews{
    margin-bottom: 30px;
}
.homepage-reviews .reviews-content{
    width: 345px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.homepage-reviews .reviews-content li{
    width: 172px;
    overflow:hidden;
    margin-bottom:20px;
}
.homepage-reviews .reviews-content li>img{
    width: 168px;
}
.homepage-reviews .reviews-content li .rev-title{
    font-size: 12px;
    font-weight: bold;
    line-height: 30px;
    color: #282b2c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.homepage-reviews .reviews-content li .rev-name-time{
    font-size: 10px;
    color: #747d80;
    margin-bottom: 4px;
}
.homepage-reviews .reviews-content li .rev-name{
    width: 166px;
    font-size: 10px;
    color: #747d80;
    margin-bottom: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.homepage-reviews .reviews-content li .rev-bottom{

}
.homepage-reviews .reviews-content li .rev-bottom .tag{
    font-size: 10px;
    color: #282b2c;
    text-indent: -25px;
    margin-left: 3px;
}
.homepage-reviews .reviews-content li .rev-bottom .tag-img{
    width: 18px;
    height: 18px;
    display: inline-block;
    position: relative;
    top:3px;
}
.homepage-reviews .reviews-content li .rev-bottom  .zan{
    font-size: 10px;
    color: #747d80;
    margin-left: 3px;
}
.homepage-reviews .reviews-content li .rev-bottom  .zan-img{
    width: 13px;
    height: 13px;
    display: inline-block;
    margin-left: 48px;
    position: relative;
    top: 1px;
}
</style>
